(function () {
  'use strict';

  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
      , 'chart.js'
    );

  angular.module('MktzapApp.Controllers')
    .controller('ReportsMailingSpecificController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'LangService', 'NotificationFactory', 'MailingCampaignService', 'NotificationService', 'ReportsService'];

  function reports ($scope, $http, $timeout, ngTableParams, LangService, NotificationFactory, MailingCampaignService, NotificationService, ReportsService) {
    var vmRMailingSpecific = this;

    LangService
      .getPageLabels({ 'page': 'menu.reports.mailing.specific' })
      .$promise
      .then(function (data) {
        vmRMailingSpecific.labels = data.lang;
      });

    $scope.vmRMailingSpecific = vmRMailingSpecific;

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    vmRMailingSpecific.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      campaign: '',
      status: ''
    };

    MailingCampaignService
      .getCampaigns()
      .$promise
      .then(function (obj) {
        vmRMailingSpecific.campaigns = obj;
      })
      .catch(function (error) {
        errorHandler(error, vmRMailingSpecific.labels.errorLoadCamp);
      });

    vmRMailingSpecific.download = function () {
      vmRMailingSpecific.loading = true;
      $http.get(apiUrl + '/reports/common/MailingSpecific', {
        params: {
          filters: vmRMailingSpecific.filters
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data) {
            if (data.success === false) {
              NotificationService.errorHandler(data, data.message);
              return;
            }

            if (data.indexOf('no_records') >= 0) {
              NotificationService.warningHandler(data, $scope.labels.noRecordsFound);
              return;
            }

            var filename = headers('Mktzap-Filename');

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' });
            angular.element(document.body).append(anchor);

            var blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]),
              data], { type: 'charset=utf-8' });

            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove();
            URL.revokeObjectURL(csvUrl);
          } else {
            NotificationService.warningHandler(null, vmRMailingSpecific.labels.noRecordsFound);
          }
        }, function ({ data }) {
          vmRMailingSpecific.filters.sendByEmail = true;
          vmRMailingSpecific.filters.typeReport = 6;
          vmRMailingSpecific.filters.reportTitle = vmRMailingSpecific.labels.title;
          vmRMailingSpecific.filters.emailMessage = vmRMailingSpecific.labels.emailMessage;

          ReportsService
            .get({
              name: 'MailingSpecific',
              filters: vmRMailingSpecific.filters
            })
            .$promise
            .then(function (result) {
              NotificationService.warningHandler(null, vmRMailingSpecific.labels.sendingByEmail);
            })
            .catch(function (data) {
              NotificationService.warningHandler(data, vmRMailingSpecific.labels.errorSendingByEmail);
            });
        })
      vmRMailingSpecific.loading = false;
    };
  }
})();
